import React from 'react';

const ArrowConnection = ({ startX, startY, endX, endY, color = '#4F47E5' }) => {
    return (
        <svg
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: 50
            }}
        >
            {/* Main line */}
            <line
                x1={startX}
                y1={startY}
                x2={endX}
                y2={endY}
                stroke={color}
                strokeWidth="2"
                strokeDasharray="5,5"
            />
        </svg>
    );
};

export default ArrowConnection; 